import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { schedularTherapistFilterAction } from '../../actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  GET_ALL_MAINTAINED_THERAPISTS_FAILURE,
  GET_ALL_MAINTAINED_THERAPISTS_REQUEST,
  GET_ALL_MAINTAINED_THERAPISTS_SUCCESS,
} = schedularTherapistFilterAction;

function* getAllMaintainedTherapist(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.getAllMaintainedTherapists,
      action.payload
    );
    if (response?.status === 200) {
      yield put({
        type: GET_ALL_MAINTAINED_THERAPISTS_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ALL_MAINTAINED_THERAPISTS_FAILURE, payload: error });
  }
}

function* getAllMaintainedTherapistSaga() {
  yield takeEvery(GET_ALL_MAINTAINED_THERAPISTS_REQUEST, getAllMaintainedTherapist);
}

export default getAllMaintainedTherapistSaga;
